/*
 * @Description: 中国智兔 资产盘点
 * @Author: gaolei
 * @Date: 2026-01-29
 * @LastEditTime: 2026-01-29
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
import { loading } from '@/utils/loading'
// import { showToast } from 'vant'
import { useUsersStore } from '@/stores/users'
import router from '@/router'
import { getQueryString } from '@/utils'
import { updateUserInfo } from './userInfo'

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const invokeMethod = async (name: string, params: string): Promise<any> => {
  try {
    // console.log('invokeMethod called with name:', params);
    if (window.flutter_inappwebview) {
      // console.log('window.flutter_inappwebview is available');
      if (typeof window.flutter_inappwebview.callHandler === 'function') {
        // console.log('window.flutter_inappwebview.callHandler is a function');
        return await window.flutter_inappwebview.callHandler(name, params)
      } else {
        await sleep(200)
        return window.flutter_inappwebview.callHandler(name, params)
      }
    } else {
      // console.error('window.flutter_inappwebview is not available');
      setTimeout(() => {
        window.location.replace(location.href)
      }, 200)
      return ''
    }
  } catch (error) {
    console.error('Error in invokeMethod:', error);
    return ''
  }
}


export const wisdomRabbitLogin = async () => {
  loading.show()
  const res = await invokeMethod('flutterBridge', 'getToken')
  loading.hide()

  if (!res) {
    return {}
  }
  const authStore = useAuthStore()
  const usersStore = useUsersStore()
  const { setCollegeId } = usersStore
  const data = res.data

  console.log('智兔data', data);

  const { stanToken: token, tenantId, collegeId, language } = data

  console.log('智兔学院collegeId', collegeId);
  localStorage.setItem('sandsTalkToken', token)
  localStorage.setItem('sandsTalkTenantId', tenantId || '1000')
  localStorage.setItem('lang', language || 'id')
  authStore.setAccessToken(token)
  setCollegeId(collegeId)
  router.replace('/')
  return token
}

export const isCnRabbitAppAssetInv = (): boolean => {
  const source = getQueryString('source') === 'cn_rabbit_app_project' || window.navigator.userAgent.indexOf('cn_rabbit_app_project') > -1
  return source
}

export const cnRabbitAssetInvLogin = async (): Promise<boolean> => {
  if (!isCnRabbitAppAssetInv()) {
    return false
  }

  // await joinSandsTalkDriver()
  const rawToken = getQueryString('token') || ''
  const tenantId = getQueryString('tenantId') || '1000'
  const collegeId = getQueryString('collegeId') || ''
  const sourceType = getQueryString('sourceType') || ''
  const jumpModuleId = getQueryString('jumpModuleId') || '' // 考试id
  // 免登成功前，先持久化司机环境标记，避免后续路由丢失 query
  localStorage.setItem('isCnRabbitAppAssetInv', 'cnRabbitAppProject')

  // token 为 encodeURI 传入，这里按需求使用 decodeURI
  const token = rawToken ? rawToken : ''

  // 没有 token 的情况下做兜底跳转
  if (!token) {
    const redirectPath =
      sourceType === 'exam' && jumpModuleId
        ? `/examPreflight?examId=${jumpModuleId}`
        : (sourceType === 'task' ? '/task' : '/')
    router.replace(`/login?redirect=${redirectPath}`)
    return false
  }

  const authStore = useAuthStore()
  const usersStore = useUsersStore()
  authStore.setAccessToken(token)
  localStorage.setItem('sandsTalkToken', token)
  localStorage.setItem('sandsTalkTenantId', tenantId)

  if (collegeId) {
    usersStore.setCollegeId(collegeId)
  }

  try {
    await updateUserInfo()
  } catch (e) {
    console.warn('updateUserInfo failed after cn_rabbit_app_project auto-login:', e)
  }

  if (sourceType === 'exam' && jumpModuleId) {
    // 进入中转页，加载考试信息后自动跳转试卷
    router.replace({ path: '/examPreflight', query: { examId: jumpModuleId } })
  } else if (sourceType === 'task') {
    router.replace('/task')
  } else {
    router.replace('/')
  }

  return true
}

export const wisdomRabbitSetTitle = (str: string) => {
  window.flutter_inappwebview.callHandler('flutterSetTitleName', str)
}

export const wisdomRabbitSetHoriVerti = (isFull: boolean) => {
  window.flutter_inappwebview.callHandler('flutterSetHoriVerti', isFull)
}

export const wisdomRabbitDownloadH5Url = (url: string) => {
  window.flutter_inappwebview.callHandler('flutterDownloadH5Url', url)
}


export const wisdomRabbitGoToNativeLoadUrl = (url: string) => {
  window.flutter_inappwebview.callHandler('flutterLoadUrl', url)
}

export const wisdomRabbitCloseWebview = () => {
  window.flutter_inappwebview.callHandler('flutterH5LoginOutFrmHome', '')
}

export const tudoGetLang = async () => {
  // 改为从 UA 中获取语言
  return getLangFromUA()
}

// 从 UA 中解析多语言（如 lang=zh-CN、language=en-US、locale=zh_CN，或自定义嵌入在 app UA 中）
// 失败时回退到 navigator.language，最终统一成小写短横线格式：zh-cn / en-us
const getLangFromUA = (): string => {
  const ua = window.navigator.userAgent || ''
  const candidates: Array<RegExp> = [
    // lang=xx-XX / language=xx-XX / locale=xx-XX / 也兼容空格、冒号、斜杠
    /(?:^|[;()\s])(?:lang(?:uage)?|locale)[=/: ]\s*([a-zA-Z]{2}(?:[-_][a-zA-Z]{2})?)/i,
    // 兼容可能写在 cn_rabbit_app 后的语言标识（例如 cn_rabbit_app/zh-CN 或 cn_rabbit_app_zh-CN）
    /cn_rabbit_app[^\w]?([a-zA-Z]{2}(?:[-_][a-zA-Z]{2})?)/i,
    // 通用兜底：捕获形如 en-US 的片段
    /(^|[^\w])([a-zA-Z]{2}-[a-zA-Z]{2})([^\w]|$)/,
  ]

  for (const re of candidates) {
    const m = ua.match(re)
    const raw = (m && (m[2] || m[1])) || ''
    if (raw) {
      return normalizeLang(raw)
    }
  }

  // 回退到浏览器首选语言
  return normalizeLang(window.navigator.language || 'zh-CN')
}

const normalizeLang = (lang: string): string => {
  let l = (lang || '').toLowerCase().replace('_', '-')
  // 常见最简写规范化
  if (l === 'zh') l = 'zh-cn'
  if (l === 'en') l = 'en-us'
  return l
}

